export const categories = [
  {
    id: "statement",
    name: "官方声明",
    description: "就重大事项发布的正式立场文件，明确事实与边界。",
    icon: "ri-quill-pen-line",
  },
  {
    id: "refute",
    name: "辟谣澄清",
    description: "针对已扩散的不实说法逐条澄清，并给出核实依据。",
    icon: "ri-shield-check-line",
  },
  {
    id: "response",
    name: "官方回应",
    description: "就公众关切的具体问题给出说明与处理进展。",
    icon: "ri-chat-quote-line",
  },
  {
    id: "notice",
    name: "公告通知",
    description: "渠道、流程与页面等服务性调整的对外通知。",
    icon: "ri-megaphone-line",
  },
] as const;